jQuery(document).ready(function($){
  "use strict";
  var cnt = 1;
jQuery(".custom-add-cart").each(function () {
    jQuery(this).attr('id', function (index) {
        return "button-" + cnt;
    });
    cnt++;
});

  jQuery(".custom.product-desc").each(function () {
    jQuery(this).attr('id', function (index) {
        return "product-" + cnt;
    });
    cnt++;
});

    //  TESTIMONIALS CAROUSEL HOOK
    $('#customers-testimonials').owlCarousel({
        loop: true,
        center: true,
        items: 3,
        margin: 0,
        autoplay: true,
        dots:true,
        autoplayTimeout: 8500,
        smartSpeed: 450,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          1170: {
            items: 3
          }
          
        }
    });
    $('#community').owlCarousel({
        loop: true,
        center: false,
        items: 6,
        margin: 0,
        autoplay: true,
        dots:false,
        arrows: true,
        autoplayTimeout: 8500,
        smartSpeed: 450,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 2
          },
          1170: {
            items: 5
          }
        }
    });


  $(document).ready(function(){
    $("img.gallery-image").click(function(){
       var src_value = $(this).attr('src');
      $("#large-image").attr('src',src_value);
       $("#show_image_popup").show()
    })
  })
  
  $("#close-btn").click(function(){
	
	$("#show_image_popup").hide()
})
                         
})